import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { PreviewTokenResponse, ResponseDto } from "@mimber/schema"

/**
 * Hook for generating a preview token for an unpublished donation page.
 * The token allows admins to preview the public page before publishing.
 */
export const useGenerateDonationPagePreviewToken = (
  pageUuid: string,
  options: Omit<
    UseMutationOptions<ResponseDto<PreviewTokenResponse>, Error, void>,
    "mutationFn"
  > = {}
): UseMutationResult<ResponseDto<PreviewTokenResponse>, Error, void> => {
  guardAppUsage("mimber-organization", "useGenerateDonationPagePreviewToken")

  const { server } = useServerContext()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.post<ResponseDto<PreviewTokenResponse>>(
        `donations/pages/${pageUuid}/preview-token`,
        {}
      )
      return response.data
    },
  })
}
